import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckInProcessType, ICheckInProcessType, IReservationProcessType } from '@curbnturf/entities';
import { DisplayValidationErrorsDirective, EnumSelectorPipe } from '@curbnturf/form-helpers';
import { listingComplete } from '@curbnturf/helpers';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'curbnturf-booking-form',
  templateUrl: './booking-form.component.html',
  styleUrls: ['./booking-form.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    DisplayValidationErrorsDirective,
    NgFor,
    EnumSelectorPipe,
  ],
})
export class BookingFormComponent {
  @Input() form: FormGroup<{
    reservationProcess: FormControl<IReservationProcessType['type'] | null>;
    checkInProcess: FormControl<ICheckInProcessType['type'] | null>;
    checkIn: FormControl<string | null>;
    checkOut: FormControl<string | null>;
    nextReservationDiscount: FormControl<number | null>;
    minLengthOfStayInDays: FormControl<number | null>;
    maxLengthOfStayInDays: FormControl<number | null>;
    bookingWindow: FormControl<number | null>;
    reserveDaysInAdvance: FormControl<number | null>;
  }>;

  times = [
    { value: '07:00:00', name: '7 am' },
    { value: '08:00:00', name: '8 am' },
    { value: '09:00:00', name: '9 am' },
    { value: '10:00:00', name: '10 am' },
    { value: '11:00:00', name: '11 am' },
    { value: '12:00:00', name: 'Noon' },
    { value: '13:00:00', name: '1 pm' },
    { value: '14:00:00', name: '2 pm' },
    { value: '15:00:00', name: '3 pm' },
    { value: '16:00:00', name: '4 pm' },
    { value: '17:00:00', name: '5 pm' },
    { value: '18:00:00', name: '6 pm' },
    { value: '19:00:00', name: '7 pm' },
    { value: '20:00:00', name: '8 pm' },
    { value: '21:00:00', name: '9 pm' },
  ];

  listingComplete = listingComplete;

  checkInProcessTypes = CheckInProcessType;

  get reservationProcess() {
    if (this.form) {
      return this.form.controls.reservationProcess;
    }

    return;
  }

  get checkInProcess() {
    if (this.form) {
      const control = this.form.controls.checkInProcess;
      const value = control?.value;

      if (value === 'meetAndGreet') {
        control?.setValue('meetAndGreet');
      }

      return control;
    }

    return;
  }

  get reserveDaysInAdvance() {
    if (this.form) {
      return this.form.get('reserveDaysInAdvance') as FormControl<number | null>;
    }

    return;
  }

  get bookingWindow() {
    if (this.form) {
      return this.form.get('bookingWindow') as FormControl<number | null>;
    }

    return;
  }

  get minLengthOfStayInDays() {
    if (this.form) {
      return this.form.get('minLengthOfStayInDays') as FormControl<number | null>;
    }

    return;
  }

  get maxLengthOfStayInDays() {
    if (this.form) {
      return this.form.get('maxLengthOfStayInDays') as FormControl<number | null>;
    }

    return;
  }

  get checkIn() {
    if (this.form) {
      return this.form.get('checkIn') as FormControl<string | null>;
    }

    return;
  }

  get checkOut() {
    if (this.form) {
      return this.form.get('checkOut') as FormControl<string | null>;
    }

    return;
  }

  get disallowShortRequestNotice() {
    return this.reservationProcess?.value === 'standard';
  }

  get disallowBookingRequestOption() {
    return (
      this.reserveDaysInAdvance &&
      this.reserveDaysInAdvance.value !== undefined &&
      this.reserveDaysInAdvance.value !== null &&
      this.reserveDaysInAdvance.value < 1
    );
  }
}
